export default {
      id: "login-admin-usage",
      viewBox: "0 0 40 32",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#login-admin",
      toString: function () {
        return this.url;
      }
    }